import dayjs from "dayjs";
import download from "downloadjs";

export const exportToExcel = (binaryData: any, name = "file", ext = "xlsx") => {
  const file = new File([binaryData], name, {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });
  download(file, `${name} ${dayjs().format("DD-MM-YYYY HH:mm:ss")}.${ext}`);
};
